import { Camera, LucideIcon, ShieldCheck, Move3D } from 'lucide-react';

export interface Partner {
  name: string;
  role: string;
  description: string;
  website: string;
  location: string;
  icon: LucideIcon;
  gradient: string;
  badge?: string; // optional label such as "Premiumpartner"
  detailHref?: string;
}

export const partners: Partner[] = [
  {
    name: 'Andreas Stedtler',
    role: 'Fotografie',
    description: 'Professionelle Fotografie für Webseiten, Portraits und Unternehmen. Andreas Stedtler liefert hochwertige Bilder, die Ihre Online-Präsenz perfekt ergänzen.',
    website: 'https://www.foto-stedtler.de/',
    location: 'Wernigerode',
    icon: Camera,
    gradient: 'from-primary to-orange-400',
  },
  {
    name: 'eRecht24',
    role: 'Rechtssichere Texte',
    description: 'Als Premiumpartner von eRecht24 nutzen wir ihre rechtssicheren Impressums- und Datenschutzvorlagen direkt und können Sie damit optimal absichern.',
    website: 'https://www.e-recht24.de/',
    location: 'Deutschland',
    icon: ShieldCheck,
    gradient: 'from-blue-500 to-cyan-400',
    badge: 'Premiumpartner',
    detailHref: '/netzwerk/erecht24',
  },
  {
    name: 'Ben Kruse',
    role: 'Fotografie',
    description: 'Fotograf aus Blankenburg, spezialisiert auf emotionale und authentische Business- und Produktfotografie.',
    website: 'https://benkruse.net/',
    location: 'Blankenburg',
    icon: Camera,
    gradient: 'from-green-400 to-teal-500',
  },
  {
    name: 'Colin Ernst',
    role: 'Animation & 3D',
    description: 'Animations- und 3D-Visualisierer, der eindrucksvolle Grafiken und Videos für Webseiten erstellt.',
    website: 'https://c-designs.de/',
    location: 'Deutschland',
    icon: Move3D,
    gradient: 'from-purple-500 to-indigo-400',
  },
];
